import React from "react";
import Rating from "./Rating";

const GridItem = (props) => {
  const { item, onHover } = props;
  const featuredUrl = item.featured_image?.image_url || '';
  return (
    <div className="col-lg-6 col-md-6"
      onMouseEnter={e => onHover(item)}
      onMouseLeave={e => onHover(null)}
    >
      <a
        href={`/listing/${item.slug}`}
        className="utf_listing_item-container"
        data-marker-id={`${item.id}`}
        target="_blank"
      >
        <div
          className="utf_listing_item"
          data-name={`${item.name}`}
          data-address={`${item.full_address}`}
          data-image={`${featuredUrl}`}
          data-lat={item.lat}
          data-lng={item.lng}
          data-url={`/listing/${item.slug}`}
          data-marker-url="https://swanpass.com/wp-content/uploads/2023/02/pin-normal-soapy.png"
          data-distance=""
          data-selected-marker-url="https://swanpass.com/wp-content/uploads/2023/02/pin-selected-soapy.png"
        >
          <img
            alt={`${item.name}`}
            className="lazyload"
            loading="lazy"
            width="410"
            height="300"
            src={`${featuredUrl}`}
          />

          <div className="utf_listing_item_content">
            <div className="listing-cats">
              {
                item.categories.map((cat) => (
                  <span key={`dcat-${cat}`} className="listing-cat-name">{cat}</span>
                ))
              }
            </div>
            <h3>{item.name}</h3>
            <span
              className="item-full-address"
              title={item.full_address}
            >
              <i className="fa fa-map-pin"></i> {item.full_address}
            </span>
            {
                item.phone &&  <span>
                <i className="fa fa-phone"></i> {item.phone}
              </span>

              }
          </div>
        </div>
        <div className="utf_star_rating_section" data-rating="5.0">
          <div className="utf_counter_star_rating">({item.reviews_count})</div>
          <span className="utf_view_count">
            <i className="fa fa-eye"></i> {item.views_count}
          </span>
          <span
            className={`like-icon ${item.favorited ? 'liked' : ''}`}
            data-remote-url={`/listing/${item.slug}/favarite`}
          ></span>
          <Rating value={item.avg_rating}/>
        </div>
      </a>
    </div>
  );
};

export default GridItem;
